export const sygnet = ['160 160', `
 B2B
`]
